import React, { memo } from 'react';
interface DecorativeShapeProps {
  color?: string;
  className?: string;
  delay?: number;
  type?: 'circle' | 'square' | 'blob' | 'donut';
}
// Memoized — these are purely decorative and never change after mount
export const DecorativeShape = memo(function DecorativeShape({
  color = 'bg-teal/10',
  className = '',
  delay = 0,
  type = 'circle'
}: DecorativeShapeProps) {
  const borderRadius = type === 'blob' ? '30% 70% 70% 30% / 30% 30% 70% 70%' : type === 'square' ? '20%' : '50%';
  const isDonut = type === 'donut';
  const animClass = type === 'square' ? 'animate-float-rotate' : 'animate-float-gentle';
  return <div className={`absolute -z-10 ${animClass} ${isDonut ? 'bg-transparent border-[20px]' : ''} ${className}`} style={{
    backgroundColor: isDonut ? 'transparent' : undefined,
    borderColor: isDonut ? color.replace('bg-', '') : undefined,
    borderRadius,
    animationDelay: `${delay * -2}s`
  }} aria-hidden="true" data-id="element-75" data-mp="ospg2aavkl97">
      {!isDonut && <div className={`w-full h-full ${color} rounded-[inherit]`} data-id="element-76" data-mp="v2s6e9wul30y" />}
    </div>;
});